module.exports = __webpack_public_path__ + "static/media/logo-login.e0c1bf24.png";